import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector,useDispatch } from "react-redux";
import * as notificationActions from "../../Redux/Actions/notifications";
import { toastMessage } from "../../utils/toast";
import * as commonActions from "../../Redux/Actions/common";
import { dateTimeFormat, serializeJsonString } from "../../utils";
import Warning from "../Ui/400";
import NotificationHeaderArea from "./NotificationHeaderArea";
import NotificationLoader from "./NotificationLoader";
import NotificationPaginate from "./NotificationPaginate";
import { Badge } from "evergreen-ui";
import SnoozeModal from "./snoozeModal";
import { MdAlarm } from 'react-icons/md';

const Notifications = ({ history }) => {
  const [data, setData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const pageLoading = useSelector(({ Common }) => Common.pageLoading);
  const dispatch = useDispatch();
  const [errStatus] = useState(200);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [snoozeModal, setSnoozeModal] = useState(false);
  const [snoozeData, setSnoozeData] = useState([]);
  const [read, setRead] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  let itemsPerPage = 10;
  const { t } = useTranslation();

  const NotificationFetchIntervlInMilliSeconds = 300000;

  useEffect(()=>{
    handleGetAllNotifications(read);
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => {
    handleGetAllNotifications(read);
  }, NotificationFetchIntervlInMilliSeconds);

  return () => clearInterval(interval);
  // eslint-disable-next-line
  }, [read]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const handleGetAllNotifications = (val) => {
    dispatch(commonActions.pageLoading(true));
    notificationActions
      .getAllNotifications(val)
      .then(({ data }) => {
        if (data) {
          let dataManipulation = [];
          data.map((e) => dataManipulation.push({ isChecked: false, ...e }));
          setData(dataManipulation);
        }
        dispatch(commonActions.pageLoading(false));
      })
      .catch((err) => {
        toastMessage(
          "error",
          (err && err.message) || `Unable to get Notifications`
        );
        dispatch(commonActions.pageLoading(false));
      });
  };

  const handleArchived = (val) => {
    dispatch(commonActions.pageLoading(true));
    setRead(val);
    notificationActions
      .getArchived(val)
      .then(({ data }) => {
        if (data) {
          setData(data);
        }
        dispatch(commonActions.pageLoading(false));
      })
      .catch((err) => {
        toastMessage(
          "error",
          (err && err.message) || `Unable to get Notifications`
        );
        dispatch(commonActions.pageLoading(false));
      });
  }

  const handleItemSelection = (item) => {
    let newCurrentItmes = [...currentItems];
    let objIndex = newCurrentItmes.findIndex((obj) => obj.id === item);
    newCurrentItmes[objIndex].isChecked = !newCurrentItmes[objIndex].isChecked;
    setCurrentItems(newCurrentItmes);
  };

  const handleMarkAsRead = () => {
    let markAsReadFlag = 1;
    let selectedItems = [];
    data.map((e) => { 
      if (e.isChecked === true) {
        selectedItems.push(e.id);
      }
    });
    if (selectedItems.length === 0) {
      toastMessage("warning", "Select Any notification for marking as read.");
    } else {
      submitSelectionForMarkUsRead(selectedItems, markAsReadFlag);
    }
  };

  const handleSnoozeModal = () => {
    let selectedItems = [];
    data.map((e) => { 
      if (e.isChecked === true) {
        selectedItems.push(e.id);
      }
    });
    if (selectedItems.length === 0) {
      toastMessage("warning", "Select Any notification for Snooze On.");
    } else {
      setSnoozeModal(preState => !preState);
      setSnoozeData(selectedItems);
    }
  }

  const handleSnoozeOff = () => {
    setButtonLoading(true);
    let selectedItems = [];
    data.map((e) => { 
      if (e.isChecked === true) {
        selectedItems.push(e.id);
      }
    });
    if (selectedItems.length === 0) {
      toastMessage("warning", "Select Any notification for Snooze Off.");
      setButtonLoading(false);
    } else {
      notificationActions.snoozeSetOff(selectedItems).then((res) => {
        if (res && res.data) {
         window.location.reload();
        } else {
          setButtonLoading(false);
          toastMessage(
            "error",
            (res && res.message) || "something went wrong, Try again later"
          );
        }
      });
    }
  }

  const submitSelectionForMarkUsRead = (selectedItems, markAsReadFlag) => {
    notificationActions.markAsRead(selectedItems).then((res) => {
      if (res && res.data) {
        if(markAsReadFlag) {
          window.location.reload();
        }
      } else {
        toastMessage(
          "error",
          (res && res.message) || "something went wrong, Try again later"
        );
      }
    });
  };

  const handleSelectAll = () => {
     let selectedItems = [];
    currentItems.map((e) => {
      e.isChecked = true;
      selectedItems.push(e);
    });
    setCurrentItems(selectedItems);
  };

  const handleGoToRoute = (notiId,jsonObj) => {
    submitSelectionForMarkUsRead([notiId]);
    if(jsonObj?.jobId){
      history.push(`/jobs/${jsonObj?.jobId}`)
    }else if(jsonObj?.refundId){
      history.push(`/refunds/${jsonObj?.refundId}`);
    }else if(jsonObj?.bulkJobId){
      history.push(`/corporate-jobs/${jsonObj?.bulkJobId}`);
    }
  }

  if (errStatus === 400) {
    return <Warning history={history} />;
  }

  return (
    <div className="container-fluid">
      <div className="page-title-box">
        <h4 className="page-title my-2">{t("notifications.title")}</h4>
      </div>
      <div className="row">
        <div className="col-lg-12 col-xxl-12">
          <div className="card card-custom card-stretch gutter-b">
            <div className="card-body">
              <div className="tab-content">
                <NotificationHeaderArea
                  t={t}
                  setButtonLoading={setButtonLoading}
                  buttonLoading={buttonLoading}
                  handleMarkAsRead={handleMarkAsRead}
                  handleSelectAll={handleSelectAll}
                  handleSnoozeModal={handleSnoozeModal}
                  handleSnoozeOff={handleSnoozeOff}
                  handleArchived={handleArchived}
                />
                {pageLoading ? (
                  <NotificationLoader />
                ) : (
                  <div className="table-responsive">
                    <table className="table  table-hover">
                      <tbody>
                        {currentItems.map(
                          ({
                            message,
                            json,
                            isRead,
                            createdTime,
                            id,
                            isChecked,
                            snoozeTill
                          }) => {
                            let jsonObj = json && serializeJsonString(json);
                            let reDirectBtnName="";
                            if(jsonObj?.jobId){
                              reDirectBtnName=t("notifications.goToJob");
                            }else if(jsonObj?.refundId){
                              reDirectBtnName=t("notifications.goToRefund");
                            }else if(jsonObj?.bulkJobId){
                              reDirectBtnName=t("notifications.gotoCorporateJobDetail");
                            }

                            return (
                              <tr className="d-flex align-items-center" key={id} style={{
                                backgroundColor: isRead === true ? "#f2f5f5" : "#ffffff",
                                borderBottom: '1px solid #2d207d80'
                              }}>
                                <td className="p-0 mx-3 border-0">
                                  <input className="c-pointer"
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => {
                                      handleItemSelection(id);
                                    }}
                                  />
                                </td>
                                <td className="w-100 border-0">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <p>{snoozeTill && <MdAlarm className="mx-1"/>} {isRead || <Badge className="border-1" color="yellow" >New</Badge>}  {message}</p>
                                      <p className="text-muted">
                                        {dateTimeFormat(createdTime)}
                                      </p>
                                    </div>
                                    <div>
                                      <button
                                        onClick={() =>
                                          //jsonObj?.jobId ? handleGoToRoute(id, jsonObj.jobId, true) : handleGoToRoute(id, jsonObj?.refundId, false)
                                          handleGoToRoute(id, jsonObj)
                                        }
                                        type="button"
                                        className="d-flex btn btn-primary font-weight-bold"
                                      >
                                      {reDirectBtnName}
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                    {pageCount > 1 && (
                      <NotificationPaginate
                        pageCount={pageCount}
                        handlePageClick={handlePageClick}
                      ></NotificationPaginate>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {snoozeModal
       && <SnoozeModal 
            t={t} 
            showModal={snoozeModal} 
            handleOk={() => handleSnoozeModal()} 
            handleModalClose={()=>setSnoozeModal(false)}
            selectedItems={snoozeData}
          />
        }
    </div>
  );
};

export default Notifications;
